<template>
  <div class="carousel-banner-container">
    <div class="banner-wrap">
      <div class="banner-prev" @click="scrollBanner('left')">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="banner-next" @click="scrollBanner('right')">
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="banner-scroll" ref="bannerScroll">
        <div class="banner-list">
          <div class="banner-item" v-for="(item, index) in carouselList" :key="index">
            <el-image
              style="width: 100%; height: 100%; object-fit: cover"
              :src="item.url"
              :preview-src-list="[item.url]"
            ></el-image>
            <div class="nameType">{{item.type}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarouselComponent',
  data() {
    return {
      carouselList: [
        {
          url: require('@/assets/images/chengguo/1.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/2.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/3.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/4.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/5.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/6.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/7.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/chengguo/8.jpg'),
          type:'成果评价'
        },
        {
          url: require('@/assets/images/tiaocha/1.jpeg'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/tiaocha/1.jpeg'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/tiaocha/2.jpeg'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/tiaocha/3.png'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/tiaocha/4.png'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/tiaocha/5.png'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/tiaocha/6.jpeg'),
          type:'尽职调查'
        },
        {
          url: require('@/assets/images/pinggu/1.jpg'),
          type:'项目评估'
        },
        {
          url: require('@/assets/images/pinggu/2.jpg'),
          type:'项目评估'
        }
      ],
      isDragging: false,
      dragStartX: 0,
      scrollStartX: 0,
      lastDragX: 0,
      dragSpeed: 0,
      inertiaTimer: null,
      autoPlayTimer: null, 
      autoPlayInterval: 5000,
    }
  },
  methods: {
    scrollBanner(direction) {
      const scrollEl = this.$refs.bannerScroll
      if (!scrollEl) return
      const scrollWidth = 600 + 20 
      scrollEl.scrollBy({
        left: direction === 'left' ? -scrollWidth : scrollWidth,
        behavior: 'smooth',
      })
      this.resetAutoPlayTimer()
    },
    handleDragStart(e) {
      if (e.button !== 0) return
      this.stopAutoPlay()
      
      if (this.inertiaTimer) {
        cancelAnimationFrame(this.inertiaTimer)
        this.inertiaTimer = null
      }
      this.isDragging = true
      const container = this.$refs.bannerScroll
      this.dragStartX = e.clientX
      this.scrollStartX = container.scrollLeft
      this.lastDragX = e.clientX
      this.dragSpeed = 0
      container.style.cursor = 'grabbing'
      container.style.transition = 'none'
      container.style.userSelect = 'none'
    },
    handleDragMove(e) {
      if (!this.isDragging) return
      e.preventDefault()
      const container = this.$refs.bannerScroll
      const currentX = e.clientX
      const deltaX = currentX - this.dragStartX
      container.scrollLeft = this.scrollStartX - deltaX
      this.dragSpeed = currentX - this.lastDragX
      this.lastDragX = currentX
    },
    handleDragEnd() {
      if (!this.isDragging) return
      this.isDragging = false
      const container = this.$refs.bannerScroll
      container.style.cursor = 'grab'
      container.style.transition = 'scroll-behavior 0.2s ease'
      this.startInertiaScroll()
      this.startAutoPlay()
    },
    startInertiaScroll() {
      const container = this.$refs.bannerScroll
      let speed = this.dragSpeed * 2.5
      const friction = 0.95
      const minSpeed = 0.3

      const inertiaStep = () => {
        container.scrollLeft -= speed
        speed *= friction
        const maxScroll = container.scrollWidth - container.clientWidth
        if (container.scrollLeft <= 0) {
          container.scrollLeft = 0
          speed = 0
        }
        if (container.scrollLeft >= maxScroll) {
          container.scrollLeft = maxScroll
          speed = 0
        }
        if (Math.abs(speed) > minSpeed) {
          this.inertiaTimer = requestAnimationFrame(inertiaStep)
        } else {
          container.style.scrollBehavior = 'smooth'
          cancelAnimationFrame(this.inertiaTimer)
          this.inertiaTimer = null
        }
      }
      if (Math.abs(speed) > minSpeed) {
        this.inertiaTimer = requestAnimationFrame(inertiaStep)
      }
    },
    startAutoPlay() {
      this.stopAutoPlay()
      this.autoPlayTimer = setInterval(() => {
        this.scrollBanner('right')
      }, this.autoPlayInterval)
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    resetAutoPlayTimer() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
    checkScrollEnd() {
      const scrollEl = this.$refs.bannerScroll
      if (!scrollEl) return
      const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth
      if (scrollEl.scrollLeft >= maxScroll - 10) { 
        scrollEl.scrollTo({
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  },

  mounted() {
    const el = this.$refs.bannerScroll
    el.addEventListener('mousedown', this.handleDragStart)
    el.addEventListener('mousemove', this.handleDragMove)
    el.addEventListener('mouseup', this.handleDragEnd)
    el.addEventListener('mouseleave', this.handleDragEnd)
    this.startAutoPlay()
    el.addEventListener('scroll', this.checkScrollEnd)
  },

  beforeDestroy() {
    if (this.inertiaTimer) cancelAnimationFrame(this.inertiaTimer)
    this.stopAutoPlay()
    
    const el = this.$refs.bannerScroll
    if (el) {
      el.removeEventListener('mousedown', this.handleDragStart)
      el.removeEventListener('mousemove', this.handleDragMove)
      el.removeEventListener('mouseup', this.handleDragEnd)
      el.removeEventListener('mouseleave', this.handleDragEnd)
      el.removeEventListener('scroll', this.checkScrollEnd)
    }
  },
  activated() {
    this.startAutoPlay()
  },
  deactivated() {
    this.stopAutoPlay()
  }
}
</script>

<style scoped>
.carousel-banner-container {
  margin: 0 auto;
  padding: 10px 0;
  font-family: "Microsoft Yahei", "PingFang SC", sans-serif;
  max-width: 1600px;
}
.banner-wrap {
  position: relative;
  width: 100%;
  padding: 0 70px;
  box-sizing: border-box;
}
.banner-scroll {
  width: 100%;
  height: 400px; 
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  cursor: grab;
}

.banner-scroll::-webkit-scrollbar {
  display: none;
}
.banner-list {
  display: flex;
  width: fit-content;
  height: 100%;
}
.banner-item {
 width: 600px;
  height: 400px;
  margin-right: 20px;
  flex: 0 0 auto;
  position: relative;
}
.banner-prev,
.banner-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(15, 76, 129, 0.8);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
}

.banner-prev:hover,
.banner-next:hover {
  background: rgba(21, 101, 192, 1);
  transform: translateY(-50%) scale(1.1);
}

.banner-prev {
  left: 10px;
}

.banner-next {
  right: 10px;
}
@media (max-width: 1024px) {
  .banner-scroll {
    height: 350px;
  }
  .banner-item {
    width: 500px;
    height: 350px;
  }
}

@media (max-width: 768px) {
  .banner-scroll {
    height: 280px;
  }
  .banner-item {
    width: 400px;
    height: 280px;
  }
  .banner-prev,
  .banner-next {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  .banner-wrap {
    padding: 0 40px;
  }
}

@media (max-width: 480px) {
  .banner-scroll {
    height: 200px;
  }
  .banner-item {
    width: 300px;
    height: 200px;
    margin-right: 10px;
  }
}
.nameType{
  position:absolute;
  height: 50px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 26px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  font-weight: bold;
}
</style>